export default "__VITE_ASSET__yBQw7YdC__"